import { css } from '@fable/theme'
import { useStatsTheme } from '../../theme/ctx'

export const ReadingGoalsLoader = () => {
  const theme = useStatsTheme((s) => s.theme)

  return (
    <div
      className={css`
        position: relative;
        width: 100%;
        height: 242px;
        background-color: ${theme.colors.section.bgSecondary};
        border-radius: 16px;
      `}
    />
  )
}
